import { faChevronLeft, faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { TwitterPicker, ColorResult } from 'react-color';

type Props = {
	colors: string[];
	selectedColor: string;
	onChangeComplete: (color: ColorResult) => void;
};

const COLORS_PER_PAGE = 6;
const VIEWPORT_WIDTH = 240; // width for showing 6 colors together nicely

const CustomColorCarousel = (props: Props) => {
	const { colors, selectedColor, onChangeComplete } = props;
	const [page, setPage] = useState(0);

	const totalPages = Math.ceil(colors.length / COLORS_PER_PAGE);

	const handlePrevClick = (e: React.MouseEvent<HTMLButtonElement>) => {
		e.preventDefault();
		setPage((p) => Math.max(p - 1, 0));
	};

	const handleNextClick = (e: React.MouseEvent<HTMLButtonElement>) => {
		e.preventDefault();
		setPage((p) => Math.min(p + 1, totalPages - 1));
	};
	const handleColorChange = (color: ColorResult) => onChangeComplete(color);

	// Split colors into pages
	const pages = [];
	for (let i = 0; i < totalPages; i++) {
		pages.push(colors.slice(i * COLORS_PER_PAGE, (i + 1) * COLORS_PER_PAGE));
	}

	return (
		<div
			style={{
				display: 'flex',
				alignItems: 'center',
				position: 'relative',
				top: '5px',
				userSelect: 'none',
				width: VIEWPORT_WIDTH + 80, // extra space for buttons
			}}
		>
			<button
				onClick={handlePrevClick}
				disabled={page === 0}
			>
				<FontAwesomeIcon icon={faChevronLeft} />
			</button>

			<div
				style={{
					overflow: 'hidden',
					width: VIEWPORT_WIDTH,
					margin: '0 10px',
				}}
			>
				<div
					style={{
						display: 'flex',
						transition: 'transform 0.4s ease',
						transform: `translateX(${-page * VIEWPORT_WIDTH}px)`,
						width: `${totalPages * VIEWPORT_WIDTH}px`,
					}}
				>
					{pages.map((pageColors, idx) => (
						<div
							key={idx}
							style={{
								flex: '0 0 auto',
								width: VIEWPORT_WIDTH,
								boxSizing: 'border-box',
							}}
						>
							<TwitterPicker
								color={selectedColor}
								colors={pageColors}
								onChangeComplete={handleColorChange}
								triangle="hide"
								styles={{
									default: {
										card: {
											boxShadow: 'none',
											background: 'transparent',
											padding: 0,
											width: 'auto',
										},
									},
								}}
							/>
						</div>
					))}
				</div>
			</div>

			<button
				onClick={handleNextClick}
				disabled={page === totalPages - 1}
			>
				<FontAwesomeIcon icon={faChevronRight} />
			</button>
		</div>
	);
};

export default CustomColorCarousel;
